module.exports = __webpack_public_path__ + "img/460.7bcd9eb2.png";